import React, { memo, useEffect, useState, useLayoutEffect, useRef, RefObject } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTransition, animated } from 'react-spring';

import ListLayoutTitleComponent from "../ListLayoutTitleComponent";
import { createListComponents, LayoutLIComponent } from "../ListLayoutElemsComponent";
import { ApplicationState } from "../../../store";
import { SettingsState } from '../../../store/settings/types';
import { chooseService } from '../../../utils';


const ListLayoutComponent = () => {
  const {layouts} = useSelector((state: ApplicationState) => state.API);
  const {openedLayoutList, activeViewPosition} = useSelector((state: ApplicationState) => state.layouts);
  const {clearTextAfterSelection} = useSelector<ApplicationState, SettingsState>(state => state.settings);

  const [typedValue, setTypedValue] = useState<string>('');
  const ref = useRef<HTMLDivElement>(null);
  const [isOpacity, setIsOpacity] = useState(false);

  const list = layouts ? chooseService(
    () => createListComponents(LayoutLIComponent, layouts.children, typedValue, 0),
    () => createListComponents(LayoutLIComponent, [layouts], typedValue, 0)
  ) : null;

  useEffect(() => {
    if (clearTextAfterSelection) setTypedValue('');
    setIsOpacity(true);
  }, [openedLayoutList]);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = activeViewPosition;
    }
    setIsOpacity(false);
  }, [isOpacity]);

  if (!layouts) return null;

  const searchHandler = (event: React.FormEvent<HTMLInputElement>): void => {
    event.stopPropagation();
    const val = event.currentTarget.value;
    setTypedValue(val);
  };

  return (
    <>
      {openedLayoutList &&
      <ul
        className='list-view-container'
      >
        <ListLayoutTitleComponent searchHandler={searchHandler} value={typedValue}/>
        <div className={`scroll list-wrapper ${isOpacity ? 'opacity' : ''}`} ref={ref}>
          {list}
        </div>
      </ul>
      }
    </>
  )
};


export default ListLayoutComponent;